import { Box } from "@mui/material";
import React from "react";
import PriscriptionHeader from "./PriscriptionHeader";
import PatientDetails from "./PatientDetails";
import PrescriptionContentForReport from "./PrescriptionContentForReport";
import PrescriptionFooterForReport from "./PrescriptionFooterForReport";

const PrescriptionDetailsForReport = ({
  opdData,
  tokenCall,
}: {
  opdData: any;
  tokenCall: any;
}) => {
  return (
    <div
      className="print-container"
      style={{
        // height: "1045px",
        flexGrow: 1,
        width: "100%",
      }}
    >
      <table
        style={{
          pageBreakInside: "avoid",
          // height: "100%",
          width: "100%",
        }}
      >
        <thead>
          <tr>
            <td>
              {opdData?.businessInformation?.headerEnable && (
                <Box className="header">
                  <PriscriptionHeader
                    headerData={opdData?.businessInformation}
                  />
                </Box>
              )}
              <Box>
                <PatientDetails patientData={opdData} />
              </Box>
            </td>
          </tr>
        </thead>
        <tbody
          style={{
            height: "100%",
            verticalAlign: "top",
          }}
        >
          <tr style={{ height: "100%" }}>
            <td>
              <Box className="content">
                <PrescriptionContentForReport opdContent={opdData} tokenCall={tokenCall}  />
              </Box>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <Box className="footer">
                <PrescriptionFooterForReport footerData={opdData} />
              </Box>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default PrescriptionDetailsForReport;
